import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { borderRadius, size } from '@twisto/styles'

export const CHECKBOX_ICON_WIDTH = size[24]
export const CHECKBOX_ICON_SPACING = size[8]

export const root = (theme: Theme) => css`
  width: ${CHECKBOX_ICON_WIDTH};
  height: ${CHECKBOX_ICON_WIDTH};
  border-radius: ${borderRadius.sm};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: ${theme.palette.background.primary};
  border: 2px solid ${theme.palette.neutral[600]};
`

export const uncheckedDisabled = (theme: Theme) => css`
  background: ${theme.palette.neutral[100]};
  border-color: ${theme.palette.neutral[300]};
`

export const uncheckedError = (theme: Theme) => css`
  border-color: ${theme.palette.error[500]};
`

export const checked = (theme: Theme) => css`
  background: ${theme.palette.brand[500]};
  border: none;

  svg {
    fill: #ffffff;
  }
`

export const checkedDisabled = (theme: Theme) => css`
  background: ${theme.palette.neutral[200]};
  border: none;

  svg {
    fill: ${theme.palette.neutral[600]};
  }
`
